const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://www.crm.brickfolio.in';

export default API_BASE_URL;